import { render, staticRenderFns } from "./Artisans.vue?vue&type=template&id=73ff0f3a"
import script from "./Artisans.vue?vue&type=script&lang=js"
export * from "./Artisans.vue?vue&type=script&lang=js"
import style0 from "./Artisans.vue?vue&type=style&index=0&id=73ff0f3a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports